document.addEventListener("DOMContentLoaded", function(event) {

  // get cart data
  const getCartData = async () => {
    let cartdata = await fetch("/cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
    return cartdata;
  };

  // plus wholesale price Discount Messages updates
  function plusUpdateDiscountMessages(cart) {
    
    if (typeof cart == "undefined") {
      (async () => {
        plusUpdateDiscountMessages(await getCartData());
      })();
      return;
    }
  
    var threshold_1 = window.threshold_1;
    var threshold_2 = window.threshold_2;
    var threshold_3 = window.threshold_3;
    var add_more_message_1 = window.add_more_message_1;
    var add_more_message_2 = window.add_more_message_2;
    var add_more_message_3 = window.add_more_message_3;
    var threshold_met_1 = window.threshold_met_1;
    var threshold_met_2 = window.threshold_met_2;
    var threshold_met_3 = window.threshold_met_3;
  
    var eligibleItemsTotal = 0;
  
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var isWholesale = item.properties["_wholesale"] || false;
      if (isWholesale) {
        eligibleItemsTotal += item.price * item.quantity;
      }
    }
  
    var message_1 = document.querySelectorAll(".plus-tier-message__1");
    var message_2 = document.querySelectorAll(".plus-tier-message__2");
    var message_3 = document.querySelectorAll(".plus-tier-message__3");
  
    if (message_1.length > 0 && message_2.length > 0 && message_3.length > 0) {
      var productPrice =
        parseFloat(
          document
            .querySelector(
              ".product-single__meta .block-price .product_price_plus"
            )
            .firstChild.nodeValue.replace("$", "")
        ) * 100;
  
      console.log("productPrice", productPrice);
  
      if (eligibleItemsTotal > threshold_3) {
        message_1[0].style.display = "none";
        message_2[0].style.display = "none";
        message_3[0].style.display = "block";
        message_3[0].innerHTML = threshold_met_3;
      } else if (eligibleItemsTotal > threshold_2) {
        var threshold_3_diff = Math.ceil(
          (threshold_3 - eligibleItemsTotal) / productPrice
        );
  
        message_1[0].style.display = "none";
        message_2[0].style.display = "block";
        message_2[0].innerHTML = threshold_met_2;
        message_3[0].style.display = "block";
        message_3[0].innerHTML = add_more_message_3.replace(
          "[diff]",
          threshold_3_diff
        );
      } else if (eligibleItemsTotal > threshold_1) {
        var threshold_2_diff = Math.ceil(
          (threshold_2 - eligibleItemsTotal) / productPrice
        );
        var threshold_3_diff = Math.ceil(
          (threshold_3 - eligibleItemsTotal) / productPrice
        );
  
        message_1[0].style.display = "block";
        message_1[0].innerHTML = threshold_met_1;
        message_2[0].style.display = "block";
        message_2[0].innerHTML = add_more_message_2.replace(
          "[diff]",
          threshold_2_diff
        );
        message_3[0].style.display = "block";
        message_3[0].innerHTML = add_more_message_3.replace(
          "[diff]",
          threshold_3_diff
        );
      } else {
        var threshold_1_diff = Math.ceil(
          (threshold_1 - eligibleItemsTotal) / productPrice
        );
        var threshold_2_diff = Math.ceil(
          (threshold_2 - eligibleItemsTotal) / productPrice
        );
        var threshold_3_diff = Math.ceil(
          (threshold_3 - eligibleItemsTotal) / productPrice
        );
  
        message_1[0].style.display = "block";
        message_1[0].innerHTML = add_more_message_1.replace(
          "[diff]",
          threshold_1_diff
        );
        message_2[0].style.display = "block";
        message_2[0].innerHTML = add_more_message_2.replace(
          "[diff]",
          threshold_2_diff
        );
        message_3[0].style.display = "block";
        message_3[0].innerHTML = add_more_message_3.replace(
          "[diff]",
          threshold_3_diff
        );
      }
    }
  };
  

  // wholesale pricing msg updates
  plusUpdateDiscountMessages();

  document.addEventListener('cart:updated', function(evt) {      
    // wholesale pricing msg updates
    plusUpdateDiscountMessages(evt.detail.cart);
  });

  document.addEventListener('ajaxProduct:added', function(evt) {  
    // wholesale pricing msg updates
    plusUpdateDiscountMessages();
  });

  document.addEventListener('variant:change', function(evt) {
    console.log(evt.detail.variant);
  });




  

  // TIERED DISCOUNTS tooltip
  var discount_title = document.querySelector(".plus-discount-title");
  var discount_info_tooltip = document.querySelector(
    ".plus-discount-info-tooltip"
  );
  
  if (typeof discount_title != "undefined" && discount_title != null) {
    discount_title.addEventListener("mouseover", function () {
      discount_info_tooltip.style.display = "block";
    });
  
    discount_title.addEventListener("mouseleave", function () {
      discount_info_tooltip.style.display = "none";
    });
  
    discount_info_tooltip.addEventListener("mouseover", function () {
      this.style.display = "block";
    });
  
    discount_info_tooltip.addEventListener("mouseleave", function () {
      discount_info_tooltip.style.display = "none";
    });
  }

  
    
});

  

  
  